export const ORGANISATIONPEOPLEVIEW = 'researchers';
export const ORGANISATIONWORKITEMVIEW = 'workItems';
export const ORGANISATIONTRADESHOWSVIEW = 'tradeshows';
export const ORGANISATIONPURCHASINGVIEW = 'purchasing';
export const ORGANISATIONVCFUNDINGVIEW = 'vcFunding';
export const ORGANISATIONACQUISITIONSVIEW = 'acquisitions';
export const ORGANISATIONINVESTMENTSVIEW = 'investments';
export const ORGANISATIONCLINICALTRIALSVIEW = 'clinicalTrials';
export const ORGANISATIONSUBSIDIARIESVIEW = 'subsidiaries';
